module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BlackIt.cc0def43.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BlackIt.woff
// module id = 357
// module chunks = 3